import { ValidationErrors } from '@angular/forms';
import Debug from 'debug';
import { TSchemaPropertyType } from 'ngx-schema-form';

const debug = Debug('ecom:schema-form');

const schemaSymbol = Symbol.for('z-schema/schema');

/**
 * Suppress INVALID_TYPE error so we can have a non-required integer field
 */
export function shouldSuppressInvalidTypeErrors(errors: ValidationErrors | null): boolean {
	if (!errors || !Object.keys(errors)?.length) return false;
	// TODO: Remove once schemas have been fixed.
	const schema = Object.values(errors)?.[0]?.[schemaSymbol] || {};
	return Object.values(errors).every((error) => {
		if (error.code !== 'INVALID_TYPE') return false; // Not type error, pass error.
		const isSelect = (schema?.widget?.id || schema?.widget) === 'select';
		// Suppress error.
		if (isSelect || schema.type === 'integer') {
			debug('Suppressing schema form error', error);
			return true;
		}
		return false; // Pass error.
	});
}

export function validateRequired(model, schema): boolean {
	for (const property of schema?.required ?? []) {
		if (isEmptyRequired(model, property, schema)) return true;
	}
	return false;
}

function isEmptyRequired(model, property, schema): boolean {
	return isEmptyRequiredValue(schema?.properties?.[property]?.type ?? null, model[property]);
}

export function isEmptyRequiredValue(type: TSchemaPropertyType, value: unknown): boolean {
	switch (type) {
		case 'integer':
		case 'number':
			return typeof value !== 'number';
		case 'string':
			return typeof value === 'string' && !value.length;
		default: // istanbul ignore next
			return false;
	}
}

export function toFlatObject<T extends Record<string, any>>(obj: T, prefix = ''): Record<string, any> {
	const res: Record<string, any> = {};
	if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) return obj;
	Object.entries(obj).forEach(([key, value]) => {
		if (typeof value === 'object' && !Array.isArray(value)) {
			Object.assign(res, toFlatObject(value as T, `${prefix}${key}.`));
		} else {
			res[`${prefix}${key}`] = value as unknown;
		}
	});
	return res;
}
